import { render, staticRenderFns } from "./DocumentsGroupModal.vue?vue&type=template&id=b47fd718&"
import script from "./DocumentsGroupModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports